import { useEffect, useState } from 'react';
import { fetchFooter } from '../helpers/contentfulHelper';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';
import { FaFacebookF } from 'react-icons/fa';
import styles from '../styles/Footer.module.css';

const getIcon = (url) => {
  if (url.startsWith('mailto:')) return <MdEmail />;
  if (url.startsWith('tel:')) return <MdPhone />;

  // Google Maps (ALL variants)
  if (
    url.includes('maps.google') ||
    url.includes('google.com/maps') ||
    url.includes('maps.app.goo.gl')
  ) {
    return <MdLocationOn />;
  }

  // Facebook
  if (url.includes('facebook.com')) return <FaFacebookF />;

  return null;
};

const getDisplayText = (title, url) => {
  if (url.startsWith('mailto:')) {
    return url.replace('mailto:', '');
  }

  if (url.startsWith('tel:')) {
    return url.replace('tel:', '');
  }

  return title;
};

// ✅ helper: external links only
const isExternalLink = (url) => url.startsWith('http');

// ✅ helper: better aria labels
const getAriaLabel = (title, url) => {
  if (
    url.includes('maps.google') ||
    url.includes('google.com/maps') ||
    url.includes('maps.app.goo.gl')
  ) {
    return 'Find us on Google Maps';
  }

  return title;
};

const Footer = () => {
  const [copy, setCopy] = useState(null);
  const [contactLinks, setContactLinks] = useState([]);
  const [address, setAddress] = useState('');

  useEffect(() => {
    const loadFooter = async () => {
      const footerEntry = await fetchFooter();

      if (footerEntry) {
        setCopy(footerEntry.fields.copy);
        setContactLinks(footerEntry.fields.contactLinks || []);
        setAddress(footerEntry.fields.address || '');
      }
    };

    loadFooter();
  }, []);

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        {copy && (
          <div className={styles.copy}>
            {documentToReactComponents(copy)}
          </div>
        )}

        {contactLinks.length > 0 && (
          <ul className={styles.contactLinks}>
            {contactLinks.map((item) => {
              const { title, url } = item.fields;
              const isExternal = isExternalLink(url);

              return (
                <li key={item.sys.id} className={styles.contactItem}>
                  <a
                    href={url}
                    target={isExternal ? '_blank' : undefined}
                    rel={isExternal ? 'noopener noreferrer' : undefined}
                    aria-label={getAriaLabel(title, url)}
                  >
                    <span className={styles.icon}>
                      {getIcon(url)}
                    </span>
                    <span className={styles.text}>
                      {getDisplayText(title, url)}
                    </span>
                  </a>
                </li>
              );
            })}
          </ul>
        )}

        {address && (
          <div className={styles.address}>
            <span>{address}</span>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;